import SuccessIcon from "../../../../assets/images/assessment-success.svg";
import FailIcon from "../../../../assets/images/pre-assessment.svg";
import CheckIcon from "../../../../assets/images/assessment-check.svg";
import CrossIcon from "../../../../assets/images/assessment-x.svg";

import Modal from "../../../modal/Modal";

import { LMS_MODULE_NAME, RETAKE_VIEW } from "../../../../utils/cookiesmanager";

import styles from "./styles.module.scss";
import Button from "../ButtonComponent";
import { BUTTON_VARIANTS } from "../constant";

const ModuleStatusComponent = (props) => {
  const {
    show,
    marks,
    handleContinue,
    handleTryAgain,
    passingMarks = 50,
    handleExit,
  } = props;

  const moduleName = localStorage.getItem(LMS_MODULE_NAME);

  const isRetake = +localStorage.getItem(RETAKE_VIEW);

  return (
    <>
      <Modal visible={show}>
        <div className={styles["assessment-wrapper"]}>
          {marks?.percentage >= passingMarks ? (
            <div className={styles["success-image"]}>
              <img src={SuccessIcon} alt="success" />
            </div>
          ) : (
            <div className={styles["success-image"]}>
              <img src={FailIcon} alt="fail" />
            </div>
          )}
          {marks?.percentage >= passingMarks ? (
            <div className={styles.title}>Congratulations</div>
          ) : isRetake ? (
            ""
          ) : (
            <div className={styles.title}>Try again!</div>
          )}

{  marks?.percentage >= passingMarks ?        
    <div className={styles.description}>
            You have completed {moduleName} . you score
            <span
              className={`${styles["numeric-result"]} ${
                marks?.percentage < passingMarks ? styles["low-score"] : ""
              }`}
            >
              {" "}
              {`${marks?.percentage}%`}
            </span>
          </div>:
          <div className={styles.description}>
            You need
            <span
              className={`${styles["numeric-result"]} ${
                marks?.percentage < passingMarks ? styles["high-score"] : ""
              }`}
            >
              {" "}
              {passingMarks} %
            </span>
            or above to complete module assessment. We encourage you to review the course and come back for another attempt.
          </div>
          }
          <div className={styles["result-wrapper"]}>
            {marks?.result?.map((item, index) => (
              <div className={styles.result} key={item.id}>
                {item?.isCorrect === 1 ? (
                  <div className={styles["result-check"]}>
                    <img src={CheckIcon} alt="check" />
                  </div>
                ) : (
                  <div className={styles["result-cross"]}>
                    <img src={CrossIcon} alt="cross" />
                  </div>
                )}

                <div>Question {index + 1}</div>
              </div>
            ))}
          </div>

          {marks?.percentage >= passingMarks ? (
            <div className={styles["button-wrapper"]}>
              <Button
                label="Continue"
                buttonVariant={BUTTON_VARIANTS.PRIMARY}
                className={styles.button}
                onClick={handleContinue}
              />
            </div>
          ) : (
            <div className={styles["button-wrapper"]}>
              <Button
                label="Exit"
                buttonVariant={BUTTON_VARIANTS.SECONDARY}
                className={styles["exit-button"]}
                onClick={handleExit}
              />
              <Button
                label="Try Again"
                buttonVariant={BUTTON_VARIANTS.PRIMARY}
                className={styles.button}
                onClick={handleTryAgain}
              />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ModuleStatusComponent;
